export default __webpack_public_path__ + "static/media/laptop_img_6.14007ec5.png";